import Enumerator from '../global/Enumerator';

export const contactDriverLicenceTypes = ['none', 'full', 'learner', 'probationary'];

export class ContactDriverLicenceType extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'full';
        break;
      case '2':
        correctOption = 'learner';
        break;
      case '3':
        correctOption = 'probationary';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

ContactDriverLicenceType.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  full: {
    get title() {
      return 'Full';
    }
  },
  learner: {
    get title() {
      return 'Learner';
    }
  },
  probationary: {
    get title() {
      return 'Probationary';
    }
  }
});

export default {
  contactDriverLicenceTypes,
  ContactDriverLicenceType
};
